export const CURRENT_VERSION = "auto";

const CHUNK_RELOAD_KEY = "ev_chunk_reloaded";
const NO_CACHE_PARAM = "ev_nocache";
const CHUNK_RELOAD_COOLDOWN_MS = 30_000;

function replaceLocation(url: string): void {
  window.location.replace(url);
}

export function reloadForUpdate(navigate: (url: string) => void = replaceLocation): void {
  if (typeof window === "undefined") {
    return;
  }

  if ("caches" in window) {
    caches
      .keys()
      .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
      .catch(() => undefined);
  }

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => Promise.all(regs.map((r) => r.update())))
      .catch(() => undefined);
  }

  const url = new URL(window.location.href);
  url.searchParams.set(NO_CACHE_PARAM, Date.now().toString());
  navigate(url.toString());
}

export function reloadOnceForUpdate(navigate: (url: string) => void = replaceLocation): void {
  if (typeof window === "undefined") {
    return;
  }
  const now = Date.now();
  const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY));
  if (lastReloadAt && now - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) {
    return;
  }
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
  reloadForUpdate(navigate);
}

export function reloadForMaintenance() {
  if (typeof window === "undefined") {
    return;
  }
  window.location.reload();
}

export function installChunkErrorRecovery() {
  if (typeof window === "undefined") {
    return;
  }

  const isChunkError = (text: string) => /ChunkLoadError|Loading chunk .* failed/i.test(text);

  const handler = (event: Event) => {
    const anyEvent = event as unknown as {
      reason?: { name?: string; message?: string };
      error?: { name?: string; message?: string };
      message?: string;
    };
    const name = anyEvent.reason?.name ?? anyEvent.error?.name ?? "";
    const message = anyEvent.reason?.message ?? anyEvent.error?.message ?? anyEvent.message ?? "";
    const text = name || message;
    if (text && isChunkError(text)) {
      reloadOnceForUpdate();
    }
  };

  window.addEventListener("unhandledrejection", handler as EventListener);
  window.addEventListener("error", handler as EventListener);
}

export function isChunkLoadError(text: string) {
  return /ChunkLoadError|Loading chunk .* failed/i.test(text);
}
